var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-body',[(!_vm.$fetchState.pending)?_c('t-sidebar-menu',{attrs:{"title":_vm.organization.name,"items":_vm.items}}):_vm._e(),_vm._v(" "),(_vm.$fetchState.pending)?_c('t-loading'):_c('nuxt-child',{attrs:{"organization":_vm.organization},on:{"updated":_vm.updated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }